<template>
  <v-main>
    <v-container fill-height fluid>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4>
          <v-card class="elevation-12">
            <ValidationObserver ref="form" v-slot="{ passes }">
              <v-card-title>
                <h3>{{ $t("language." + $store.getters.pagetitle) }}</h3>
              </v-card-title>
              <v-card-text>
                <v-form>
                  <ValidationProvider
                    :name="$t('language.emailaddress')"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      v-model="email"
                      :label="$t('language.emailaddress')"
                      :error-messages="errors[0]"
                      prepend-icon="mdi-account"
                    />
                  </ValidationProvider>
                </v-form>
              </v-card-text>

              <v-card-actions>
                <v-btn
                  align-center
                  justify-center
                  color="general"
                  @click="passes(submit)"
                  >{{ $t("language.submit") }}</v-btn
                >
                <v-spacer />
                <router-link to="/login" class="tertiary--text">{{
                  $t("language.login")
                }}</router-link>
              </v-card-actions>
            </ValidationObserver>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  data: function () {
    return {
      email: null,
      processing: false,
    };
  },
  methods: {
    submit: function () {
      if (this.processing) return;
      this.processing = true;
      axios
        .post("/account/forgotpassword", {
          email: this.email,
        })
        .then(() => {
          //this.email = null;
          this.processing = false;

          this.$store
            .dispatch(
              "setMessage",
              this.$t("language.forgetpasswordsuccessful")
            )
            .then(() => this.$router.push("/success"));
        })
        .catch((err) => {
          this.processing = false;
        });
    },
  },
  metaInfo() {
    return {
      title: this.$store.getters.applicationtitle + " | Forgot Password",
    };
  },
};
</script>
